// extracted by mini-css-extract-plugin
module.exports = {"buy_now":"BuyNow_buy_now__VZyzm"};